

































import { mapGetters } from 'vuex'
import { VEHICLE_TYPE } from '@/shared/constants'

export default {
  props: {
    order: { type: Object, required: true },
    renderAsTooltip: { type: Boolean, default: false },
    showIcon: { type: Boolean, default: true },
    truncated: { type: Boolean, default: false }
  },
  computed: {
    ...mapGetters(['vehicleTypes']),
    allowedVehicles() {
      const { allowedVehicleTypes, vehicleTypeName } = this.order
      const allowedVehicles = allowedVehicleTypes || []
      return allowedVehicles.length ? allowedVehicles : [vehicleTypeName]
    },
    shouldRenderTooltip() {
      return this.renderAsTooltip && this.allowedVehicles.length > 1
    },
    formattedVehicleTypes() {
      const delimiter = this.renderAsTooltip ? '</br>' : ', '
      return this.allowedVehicles
        .map(this.getHumanReadableVehicleName)
        .sort()
        .join(delimiter)
    },
    temperatureControlledVehicleTooltip() {
      // Show tooltip for Frigo trucks cos temperature specs overflow container
      const content = this.formattedVehicleTypes
      const showTooltip =
        this.renderAsTooltip && this.truncated && this.order.isTemperatureControlled
      return showTooltip ? { content } : null
    },
    vehicleTypesClasses() {
      return {
        paragraph: true,
        'paragraph--truncated': this.truncated,
        'm-0': true
      }
    }
  },
  methods: {
    getHumanReadableVehicleName(vehicleType) {
      const vehicleName = this.vehicleTypes[vehicleType]
      if (
        vehicleType === VEHICLE_TYPE.FRIGO_TRUCK &&
        this.order.isTemperatureControlled
      ) {
        return this.appendTemperatureSpecifications(vehicleName)
      }
      return vehicleName
    },
    appendTemperatureSpecifications(vehicleName) {
      const minTemperature = this.order.loadMinimumTemperature.toFixed(1)
      const maxTemperature = this.order.loadMaximumTemperature.toFixed(1)
      const separator = this.$t(
        'orderDetails.vehicleSpecifications.temperatureRangePreposition'
      )
      const temperatureSpecifications = `${minTemperature} ${separator} ${maxTemperature}`
      return `${vehicleName} (${temperatureSpecifications} °C)`
    }
  }
}
